"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FlexDiv = void 0;
exports.default = LearnMore;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _r10SourceLibrary = require("r10-source-library");
var _useTranslation = _interopRequireDefault(require("../../hooks/useTranslation"));
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var FlexDiv = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: 'center';\n  justify-content: center;\n"])));
exports.FlexDiv = FlexDiv;
function LearnMore(_ref) {
  var index = _ref.index;
  var t = (0, _useTranslation.default)();
  return /*#__PURE__*/_react.default.createElement(FlexDiv, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.LinkWithIcon, {
    appearance: "primary",
    text: t('learn_more'),
    icon: {
      name: 'chevron-right',
      justify: 'right'
    },
    dataAttributes: {
      'data-testid': "offer-card-learn-more-".concat(index)
    }
  }));
}
LearnMore.propTypes = {
  index: _propTypes.default.number
};